<template>
    <Modal :open="open" :show-close-icon="true" @close="closeModal" :is-card="true" :narrow="false">
        <template v-if="!submitted">
            <h2 class="apply-for-finance-modal__title">Enquire about finance</h2>
            <p class="p--center">Please select the finance you're interested in below:</p>
            <form @submit.prevent="submit" ref="form">
                <div class="form-grid form-grid--xs-1-column">
                    <template v-if="pcpQuote != null & hpQuote != null">
                        <div class="form-grid__col-span-2 form-grid__col--xs-full-width redesign-radio__container redesign-radio__container--center" id="selected-quote__container">
                            <div class="redesign-radio">
                                <input
                                    class="redesign-radio__input"
                                    type="radio"
                                    name="selected-quote"
                                    :id="_uid + '-pcp'"
                                    value="PCP"
                                    data-validate="radio"
                                    data-validate-message="Please let us know which finance quote you are interested in"
                                    data-error-target="selected-quote__container"
                                    autocomplete="off"
                                />
                                <label class="redesign-radio__label" :for="_uid + '-pcp'"><span class="redesign-radio__span"></span>{{ pcpQuote.name }}</label>
                            </div>
                            <div class="redesign-radio">
                                <input class="redesign-radio__input" type="radio" name="selected-quote" :id="_uid + '-hp'" value="HP" autocomplete="off" />
                                <label class="redesign-radio__label" :for="_uid + '-hp'"><span class="redesign-radio__span"></span>{{ hpQuote.name }}</label>
                            </div>
                        </div>
                    </template>
                    <div class="form-grid__col-span-2 form-grid__col--xs-full-width">
                        <p class="p--center">Fill in your details below and a member of our team will be in touch</p>
                    </div>
                    <div class="form-grid__col-span-2 form-grid__col--xs-full-width">
                        <customer-title />
                    </div>
                    <div class="form-grid__col form-grid__col--xs-full-width">
                        <first-name />
                    </div>
                    <div class="form-grid__col form-grid__col--xs-full-width">
                        <last-name />
                    </div>
                    <div class="form-grid__col form-grid__col--xs-full-width">
                        <email />
                    </div>
                    <div class="form-grid__col form-grid__col--xs-full-width">
                        <telephone :input-nullable="false" />
                    </div>
                    <div class="form-grid__col form-grid__col--xs-full-width">
                        <customer-location />
                    </div>
                    <div class="form-grid__col form-grid__col--xs-full-width">
                        <dealer :filter-new="true" />
                    </div>
                    <div class="form-grid__col-span-2 form-grid__col--xs-full-width">
                        <privacy></privacy>
                    </div>
                    <div class="form-grid__col-span-2 form-grid__col--xs-full-width" style="justify-self: center;">
                        <button type="submit" class="btn btn--primary btn--min-width">Continue</button>
                    </div>
                </div>
            </form>
        </template>
        <template v-else>
            <h2 class="apply-for-finance-modal__title">Thank you for your enquiry</h2>

            <ImageGallery :is-carousel="false" :small-image="true"/>

            <div class="body">
                <p>A member of our customer hub team will be in contact shortly with more details regarding your {{ model.model_title }} enquiry. </p>

                <p>Please use the links below to learn more about {{ model.model_title }} or to get behind the wheel for a personalised test drive at a time which suits you.</p>
            </div>

            <div class="apply-for-finance-modal__footer">
                <a :href="testDriveUrl" class="btn btn--primary btn--long btn--full-width-xs">Book a Test Drive</a>

                <a :href="showroomUrl" class="btn btn--primary-inverted btn--long btn--full-width-xs">Discover More</a>
            </div>
        </template>
    </Modal>
</template>

<script>
import Modal from "../../core/components/Modal.vue";
import CustomerTitle from "../../core/components/Forms/Title.vue";
import FirstName from "../../core/components/Forms/FirstName.vue";
import LastName from "../../core/components/Forms/LastName.vue";
import Email from "../../core/components/Forms/Email.vue";
import Telephone from "../../core/components/Forms/Telephone.vue";
import Privacy from "../../core/components/Forms/Privacy.vue";
import CustomerLocation from "../../core/components/Forms/CustomerLocation.vue";
import Dealer from "../../core/components/Forms/Dealer.vue";
import { mapState } from "vuex";
import ContactFormValidator from "../../validation/ContactFormValidator";
import CustomerLocationHandler from "../../modules/CustomerLocationHandler";
import { customEvent } from '../../modules/tracking/AnalyticsEvents';

export default {
    props: {
        open: {
            default: false,
        },
    },
    components: {
        Modal,
        CustomerTitle,
        FirstName,
        LastName,
        Email,
        Telephone,
        Privacy,
        CustomerLocation,
        Dealer,
    },
    data() {
        return {
            validator: null,
            customerLocationHandler: null,
            loading: false,
            submitted: false,
        };
    },
    methods: {
        closeModal() {
            this.$emit("close-modal");
        },

        async submit() {
            if (!await this.validator.isValid()) {
                return;
            }

            reCaptchaProtect(() => {
                this.$store
                    .dispatch("syncDatabase", this.$route.query)
                    .then(() => {
                        const formData = new FormData(this.$refs.form);
                        formData.append("configuratorId", this.configuratorId);
                        formData.append("deposit", this.deposit);
                        formData.append("term", this.term);
                        formData.append("mileage", this.mileage);

                        if (this.pcpQuote != null && this.hpQuote != null) {
                            if (formData.get('selected-quote') == 'PCP') {
                                formData.append('quote', JSON.stringify(this.pcpQuote));
                            } else if (formData.get('selected-quote') == 'HP') {
                                formData.append('quote', JSON.stringify(this.hpQuote));
                            }
                        } else if (this.pcpQuote != null) {
                            formData.append('quote', JSON.stringify(this.pcpQuote));
                        } else if (this.hpQuote != null) {
                            formData.append('quote', JSON.stringify(this.hpQuote));
                        }

                        this.validator.preventInput();

                        axios
                            .post('/api/configurator/send-enquiry', formData)
                            .then(() => {
                                customEvent("Configurator Final Screen", "Send Enquiry", "Complete");
                                this.validator.allowInput();
                                this.submitted = true;
                            })
                            .catch(error => {
                                console.error(error);
                                this.validator.errorResponse(error);
                            });
                    })
                    .catch(error => {
                        console.error(error);
                        this.validator.errorResponse(error);
                    });
            });
        },
    },
    computed: {
        ...mapState(['brand', 'configuratorId', 'model']),
        ...mapState('Finance', ['deposit', 'term', 'mileage', 'pcpQuote', 'hpQuote']),
        testDriveUrl() {
            return `/${this.model.brand}/book-a-test-drive/${this.model.url_model}`;
        },
        showroomUrl() {
            return `/${this.model.brand}/new/${this.model.url_model}`;
        }
    },
    watch: {
        pcpQuote: function() {
            if (this.validator) {
                this.$nextTick(function() {
                    this.validator.updateValidatableElements();
                });
            }
        },
        hpQuote: function() {
            if (this.validator) {
                this.$nextTick(function() {
                    this.validator.updateValidatableElements();
                });
            }
        },
    },
    mounted() {
        this.validator = new ContactFormValidator({
            vueForm: true,
            redesign: true,
            element: this.$refs["form"],
        });
        this.customerLocationHandler = new CustomerLocationHandler({
            element: this.$refs["form"],
            additionalLocationFilterFunction: dealer => (dealer.brand == this.brand)
        });
    },
};
</script>

<style lang="scss">
.apply-for-finance-modal {
    &__title {
        text-align: center;
        color: #192a44;
    }

    &__footer {
        display: grid;
        grid-template-columns: 1fr;
        row-gap: 15px;
        margin: 0 auto;
        @media (min-width: 768px) {
            grid-template-columns: 1fr 1fr;
            column-gap: 15px;
        }
    }
}

#selected-quote__container + .validation-error {
    grid-column: span 2;
    margin: 0 auto;
    padding: 0;
    text-align: center;
}
</style>